import { createFileRoute } from '@tanstack/react-router';

import { AdGroup, AdGroupSearchParamsSchema } from '@/features/trafficking';

export const Route = createFileRoute('/_app/trafficking/ad-unit')({
  validateSearch: AdGroupSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <AdGroup />;
}
